import { render, staticRenderFns } from "./dialogBidDetail.vue?vue&type=template&id=1b60d9db&scoped=true"
import script from "./dialogBidDetail.vue?vue&type=script&lang=js"
export * from "./dialogBidDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogBidDetail.vue?vue&type=style&index=0&id=1b60d9db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b60d9db",
  null
  
)

export default component.exports